export const PAYMENT_STEP_ROUTE = 'platnosc';
export const PAYMENT_STEP_PARAMETRIZED_ROUTE = ':id/platnosc';
